import { configMainRoutesConsts } from "../../config/route";

export const isMarketplacePage = ()=> window.location.pathname.includes(configMainRoutesConsts.marketplace.split("/:")[0])